import * as CryptoJS from 'crypto-js';

export const encrypt = (data: string): string => {
  return CryptoJS.AES.encrypt(data, 'chuchinx').toString();
};

export const decrypt = <T>(valueEncriptado: string): T | null => {
  const valueDesencriptado = CryptoJS.AES.decrypt(valueEncriptado, 'chuchinx').toString(
    CryptoJS.enc.Utf8
  );
  if (!valueEncriptado) {
    return null;
  }
  return JSON.parse(valueDesencriptado) as T;
};
